import { createHazardScoreBadge } from '../ScoreBadge'

export function hiToScore(value: number): number {
  /**
   * Convert HI value to score
   *
   * @param value - HI value
   * @return Score [1-10]
   */
  if (value < 27) {
    return 1
  } else if (value < 28) {
    return 2
  } else if (value < 30) {
    return 3
  } else if (value < 32) {
    return 4
  } else if (value < 33) {
    return 5
  } else if (value < 35) {
    return 6
  } else if (value < 37) {
    return 7
  } else if (value < 40) {
    return 8
  } else if (value < 43) {
    return 9
  } else {
    return 10
  }
}

export function scoreToCategory(score: number): number {
  /**
   * Convert score to category index
   *
   * @param score - Score [1-10]
   * @return Category index [1-5]
   */
  if (score <= 2) {
    return 1
  } else if (score <= 4) {
    return 2
  } else if (score <= 6) {
    return 3
  } else if (score <= 8) {
    return 4
  } else {
    return 5
  }
}

const heatStressLabels: Record<number, string> = {
  1: 'Low',
  2: 'Moderate',
  3: 'Moderate to High',
  4: 'High',
  5: 'Very High',
}

export function mapHeatIndexToCategory(value: number | null | undefined): number | null {
  if (typeof value !== 'number' || !Number.isFinite(value)) return null
  const score = hiToScore(value)
  return scoreToCategory(score)
}

export const HeatStressScoreBadge = createHazardScoreBadge({
  labels: heatStressLabels,
  // palette: heatStressPalette,
  mapScore: mapHeatIndexToCategory,
})
